import I18N from '@leverege/i18n';
import { History } from '@leverege/molten-core';
const path = '/settings';
const {
  t,
  tfIcon
} = I18N.ns('molten.screens.settings');
export default {
  id: 'link.desktop.Settings',
  matches: {
    use: 'userBar',
    client: 'Main'
  },
  layout: {
    group: ['user'],
    groupIcons: [tfIcon('profileMenuIcon')],
    sort: 'account.setting.b'
  },
  handles: context => {
    return context?.mobile !== true;
  },
  appearance: ({
    context,
    action
  }) => {
    return {
      name: t('name'),
      icon: tfIcon('accountIcon')
    };
  },
  perform: ({
    context
  }) => {
    const {
      clientProps: {
        dispatch
      }
    } = context;
    dispatch(History.push(path));
  }
};